import React from 'react';

import { Text } from 'shell/components';

const TextDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Text</Text>
            <Text variant={'h1'}>Heading 1 Medium</Text>
            <Text variant={'h1'} weight={'semibold'}>
                Heading 1 Semi Bold
            </Text>
            <Text variant={'h1'} weight={'bold'}>
                Heading 1 Bold
            </Text>
            <Text variant={'h2'}>Heading 2 Medium</Text>
            <Text variant={'h2'} weight={'semibold'}>
                Heading 2 Semi Bold
            </Text>
            <Text variant={'h2'} weight={'bold'}>
                Heading 2 Bold
            </Text>
            <Text variant={'h3'}>Heading 3 Medium</Text>
            <Text variant={'h3'} weight={'semibold'}>
                Heading 3 Semi Bold
            </Text>
            <Text variant={'h3'} weight={'bold'}>
                Heading 3 Bold
            </Text>
            <Text variant={'h4'}>Heading 4 Medium</Text>
            <Text variant={'h4'} weight={'semibold'}>
                Heading 4 Semi Bold
            </Text>
            <Text variant={'h4'} weight={'bold'}>
                Heading 4 Bold
            </Text>
            <Text variant={'h5'}>Heading 5 Medium</Text>
            <Text variant={'h5'} weight={'semibold'}>
                Heading 5 Semi Bold
            </Text>
            <Text variant={'h5'} weight={'bold'}>
                Heading 5 Bold
            </Text>
            <Text variant={'h6'}>Heading 6 Medium</Text>
            <Text variant={'h6'} weight={'semibold'}>
                Heading 6 Semi Bold
            </Text>
            <Text variant={'h6'} weight={'bold'}>
                Heading 6 Bold
            </Text>
            <Text variant={'sh1'}>Subheading 1 Regular</Text>
            <Text variant={'sh1'} weight={'medium'}>
                Subheading 1 Medium
            </Text>
            <Text variant={'sh1'} weight={'semibold'}>
                Subheading 1 Semi Bold
            </Text>
            <Text variant={'sh2'}>Subheading 2 Regular</Text>
            <Text variant={'sh2'} weight={'medium'}>
                Subheading 2 Medium
            </Text>
            <Text variant={'sh2'} weight={'semibold'}>
                Subheading 2 Semi Bold
            </Text>
            <Text variant={'p1'}>Paragraph 1 Regular</Text>
            <Text variant={'p1'} weight={'medium'}>
                Paragraph 1 Medium
            </Text>
            <Text variant={'p1'} weight={'semibold'}>
                Paragraph 1 Semi Bold
            </Text>
            <Text variant={'p2'}>Paragraph 2 Regular</Text>
            <Text variant={'p2'} weight={'medium'}>
                Paragraph 2 Medium
            </Text>
            <Text variant={'p2'} weight={'semibold'}>
                Paragraph 2 Semi Bold
            </Text>
            <Text variant={'p3'}>Paragraph 3 Regular</Text>
            <Text variant={'p3'} weight={'medium'}>
                Paragraph 3 Medium
            </Text>
            <Text variant={'p3'} weight={'semibold'}>
                Paragraph 3 Semi Bold
            </Text>
            <Text variant={'p4'}>Paragraph 4 Regular</Text>
            <Text variant={'p4'} weight={'medium'}>
                Paragraph 4 Medium
            </Text>
            <Text variant={'p4'} weight={'semibold'}>
                Paragraph 4 Semi Bold
            </Text>
        </>
    );
};

export default TextDemo;
